module.exports = __webpack_public_path__ + "static/media/eve-ada.8a9fe3a7.svg";